import LoadingComponent from '@/pages/components/loadingComponent'
import Loadable from 'react-loadable'

export default [
  {
    component: Loadable({
      loader: () => import('@/pages/eleCarQuestionnaire/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/eleCarQuestionnaire'
  }
]
